import ApiClient from ".."

// In DTOs
import MeetingGetListIn from "../../dtos/in/MeetingGetListIn"
import MeetingPatchUserFeedbackIn from "../../dtos/in/MeetingPatchUserFeedbackIn"
import MeetingPostIn from "../../dtos/in/MeetingPostIn"
import MeetingPutIn from "../../dtos/in/MeetingPutIn"

// Out DTOs
import GenericOut from "../../dtos/out/GenericOut"
import MeetingGetListOut from "../../dtos/out/MeetingGetListOut"
import MeetingGetOut from "../../dtos/out/MeetingGetOut"
import MeetingPostOut from "../../dtos/out/MeetingPostOut"

export class MeetingEndpoints {
  constructor(private client: ApiClient) {}
  static readonly BASE_URL = "/meeting"

  /**
   * Deletes a meeting note.
   */
  async delete(meetingNoteId: number) {
    return this.client.delete<GenericOut>(MeetingEndpoints.BASE_URL, `/${meetingNoteId}`)
  }

  /**
   * Retrieves a meeting note's details.
   */
  async get(meetingNoteId: number) {
    return this.client.get<MeetingGetOut>(MeetingEndpoints.BASE_URL, `/${meetingNoteId}`)
  }

  /**
   * Retrieves a list of all meeting notes with filters, ordering, and pagination.
   */
  async getList(payload: MeetingGetListIn) {
    return this.client.get<MeetingGetListOut>(MeetingEndpoints.BASE_URL, "/", payload)
  }

  /**
   * Retrieves a list of meeting notes for a client (user) with filters, ordering, and pagination.
   */
  async getListForClient(userId: number, payload: MeetingGetListIn) {
    return this.client.get<MeetingGetListOut>(MeetingEndpoints.BASE_URL, `/user/${userId}`, payload)
  }

  /**
   * Retrieves a list of meeting notes for a coach with filters, ordering, and pagination.
   */
  async getListForCoach(coachId: number, payload: MeetingGetListIn) {
    return this.client.get<MeetingGetListOut>(MeetingEndpoints.BASE_URL, `/coach/${coachId}`, payload)
  }

  /**
   * Updates user's meetingNote score and note.
   */
  async patchUserFeedback(meetingNoteId: number, payload: MeetingPatchUserFeedbackIn) {
    return this.client.patch<GenericOut>(MeetingEndpoints.BASE_URL, `/${meetingNoteId}/user-feedback`, payload)
  }

  /**
   * Creates a new meeting note for specified client (user).
   */
  async post(userId: number, payload: MeetingPostIn) {
    return this.client.post<MeetingPostOut>(MeetingEndpoints.BASE_URL, `/user/${userId}`, payload)
  }

  /**
   * Updates a meeting note.
   */
  async put(meetingNoteId: number, payload: MeetingPutIn) {
    return this.client.put<GenericOut>(MeetingEndpoints.BASE_URL, `/${meetingNoteId}`, payload)
  }
}
